import { OrganizationalUnitDTO } from '@/app/api/plyca-dtos';
import { FormConfig } from '@/app/components/forms/form.objects';
import { FormPlycaComponent } from '@/app/components/forms/formPlyca.component';
import { FormGroup } from '@angular/forms';

export class FilterPanelDemoDTO {
  cpv: string;
  dto: {
    division: {
      project: {
        organizationalUnit: OrganizationalUnitDTO;
      };
    };
  };
}

export interface FilterPanelDemoData {
  values?: unknown;
  formGroup?: FormGroup;
  isLoaded?: boolean;
  formPlycaRef?: FormPlycaComponent;
  formConfig?: FormConfig;
}
